import { Base } from '@app/shared/models/base.model'
import { Person } from '@app/modules/person/person.model'

export class User extends Base {
  uuid: string = null
  username: string = null
  password: string = null
  email: string = null
  firstName: string = null
  lastName: string = null
  personUuid: string = null
  enabled: boolean
  lastIp: string = null
  lastLogin: Date = null
  lastActive: Date = null
  rememberToken: boolean
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null
  // Relations.
  person: Person = null

  /**
   * Properties with type Date
   *
   * @type {Array<string>}
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt',
    'lastLogin',
    'lastActive'
  ]

  /**
   * Constructor
   *
   * @param {Partial<User>} data Initial values
   */
  public constructor (data?: Partial<User>) {
    super(data)
    this.init(data)
  }
}
